export enum OrderStatus {
  OPEN = "open",
  SEPARATION = "separation",
  BILLED = "billed",
  DELIVERY = "delivery",
  CLOSED = "closed",
}
